import {fromJS} from 'immutable';
import actions from '../actions/payout.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

/*
export const DEFAULT_STATE = fromJS({
    loadingData: false,
    loadingOptions: false,
    date: '2018-12',
    dateOptions: []
    data: []
});
*/

// TODO: TEMPORARY UNTIL BACKEND IS HOOKED UP
export const DEFAULT_STATE = fromJS({
    loadingData: false,
    loadingOptions: false,
    date: '',
    dateOptions: [],
    data: {}
});

export const payoutReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case actions.TYPES.GET_PAYOUT_REPORT: {
            return state.set('loadingData', true).set('date', action.payload.payoutPeriod);
        }
        case actions.TYPES.GET_PAYOUT_REPORT_COMPLETE: {
            return state.set('loadingData', false).set('data', action.payload.data);
        }
        case actions.TYPES.GET_PAYOUT_REPORT_FAILED: {
            return state.set('loadingData', false);
        }
        case actions.TYPES.GET_PAYOUT_OPTIONS: {
            return state.set('loadingOptions', true);
        }
        case actions.TYPES.GET_PAYOUT_OPTIONS_COMPLETE: {
            return state.set('loadingOptions', false)
                .set('dateOptions', action.payload ? action.payload.data : [])
                .set('date', action.payload && action.payload.data ? action.payload.data[0]: '');;
        }
        case actions.TYPES.GET_PAYOUT_OPTIONS_FAILED: {
            return state.set('loadingOptions', false);
        }
        case actions.TYPES.SET_PAYOUT_DATE: {
            return state.set('date', action.payload);
        }
        default: {
            return state;
        }
    }
};

export default dieselReducer('payout', payoutReducer);
